export const NETWORK_FILTER_CONTROL_WIDTH = 500;
export const COMPETITIVE_INSIGHTS_MAP_PADDING = 50;
export const NETWORK_FILTER_CONTROL_PADDING = NETWORK_FILTER_CONTROL_WIDTH + COMPETITIVE_INSIGHTS_MAP_PADDING;